import { Component, OnInit } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent implements OnInit {
  public mensaje:string = "ESTAMOS BUSCANDO LA MEJOR OPCIÓN";
  public cargando: number = 0;
  public tiempoCarga: number = 60000; // El tiempo se define por milisegundos
  public limiteProgressBar: number = 100;
  private _subscriptions: Subscription;

  constructor(private dialog: MatDialogRef<LoadingComponent>) { }

  ngOnInit(): void {
  let times$ = interval(this.tiempoCarga/100);
    this._subscriptions = times$.subscribe(x => {
      if(x == this.limiteProgressBar){
         this._subscriptions.unsubscribe();
         this.cargando = 99;

         if(x == 100) {
          this.dialog.close();
        }
     }

      this.cargando = x;
    }); 

   
  }

  getTiempoDeCarga():number{
    return this.tiempoCarga / 1000;
  }

  cerrarModal(){
    setTimeout(() => {
      this.dialog.close()
    }, 100);
  }
}
